const CheckLime = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <circle cx="8.57143" cy="8.57143" r="8.57143" fill="#79A02D" />
      <mask
        id="mask0_1913_14"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <circle cx="8.57143" cy="8.57143" r="8.57143" fill="#03BD7D" />
      </mask>
      <g mask="url(#mask0_1913_14)">
        <path
          d="M6.25 11.9059L7.29534 10.4868L12.9468 5.16699L19.1968 11.4886L12.5403 18.5111L6.25 11.9059Z"
          fill="#5F7E22"
        />
      </g>
      <path
        d="M11.7647 5.31064C12.0929 4.91961 12.6864 4.89544 13.046 5.25791L13.8497 6.06846C14.1873 6.40874 14.1851 6.95844 13.8448 7.296L8.3331 12.7638C8.07731 13.0175 7.70309 13.0788 7.38974 12.9493C7.28197 12.907 7.18095 12.8421 7.09385 12.755L3.7501 9.41123C3.4113 9.07229 3.41123 8.52256 3.7501 8.18369L4.45713 7.47764C4.84256 7.09227 5.4835 7.15333 5.78916 7.60459L7.56357 10.2228C7.5752 10.2399 7.5889 10.2554 7.60166 10.2716C7.60904 10.2634 7.61801 10.2566 7.6251 10.2481L11.7647 5.31064Z"
        fill="white"
      />
      <mask
        id="mask1_1913_14"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="5"
        width="12"
        height="9"
      >
        <path
          d="M11.7619 5.31281C12.09 4.92141 12.6835 4.89651 13.0432 5.2591L13.8479 6.06965C14.1851 6.40996 14.1832 6.95973 13.843 7.29719L8.33224 12.763C8.07652 13.0167 7.70216 13.0789 7.38888 12.9495C7.28112 12.9072 7.18006 12.8423 7.09298 12.7552L3.74923 9.41144C3.4105 9.07248 3.41033 8.52275 3.74923 8.18391L4.45626 7.47785C4.84169 7.09249 5.48263 7.15354 5.78829 7.6048L7.5627 10.223C7.57433 10.2401 7.58803 10.2556 7.60079 10.2718C7.60815 10.2637 7.61717 10.2568 7.62423 10.2484L11.7619 5.31281Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_1913_14)">
        <path
          d="M7.32401 14.1415C7.04868 13.7833 7.02802 13.2908 7.27238 12.9108L12.394 4.94617C13.1219 3.81422 14.7946 3.86958 15.4461 5.04718C15.8094 5.70393 15.7214 6.51807 15.226 7.08192L8.97615 14.1957C8.5313 14.702 7.73475 14.6759 7.32401 14.1415Z"
          fill="#F1F0EE"
        />
      </g>
    </svg>
  );
};

export default CheckLime;
